import type { SVGProps } from 'react';

const PATHS = {
  check: (
    <path
      d="M3.5 8.5l3 3 6-7"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  clock: (
    <>
      <circle cx="8" cy="8" r="6" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M8 4.8V8l2.2 1.6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </>
  ),
  stop: (
    <>
      <path
        d="M5.4 1.8h5.2l3.6 3.6v5.2l-3.6 3.6H5.4l-3.6-3.6V5.4z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path d="M5.5 8h5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </>
  ),
  half: (
    <>
      <circle cx="8" cy="8" r="6" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M8 2a6 6 0 0 1 0 12z" fill="currentColor" />
    </>
  ),
  play: <path d="M5 3l8 5-8 5z" fill="currentColor" />,
  lock: (
    <>
      <rect x="3" y="7" width="10" height="7" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M5.5 7V5a2.5 2.5 0 0 1 5 0v2" fill="none" stroke="currentColor" strokeWidth="1.8" />
    </>
  ),
  x: <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />,
  plus: <path d="M8 3v10M3 8h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />,
  up: (
    <path
      d="M4 10l4-4 4 4"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  down: (
    <path
      d="M4 6l4 4 4-4"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  out: (
    <path
      d="M9 3H4v10h5M7 8h7M11.5 5.5L14 8l-2.5 2.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  screen: (
    <>
      <rect
        x="1.5"
        y="2.5"
        width="13"
        height="8.5"
        rx="1.2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path d="M5 14h6M8 11v3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </>
  ),
  full: (
    <path
      d="M2 6V2h4M10 2h4v4M14 10v4h-4M6 14H2v-4"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  back: (
    <path
      d="M10 3L5 8l5 5"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  next: (
    <path
      d="M6 3l5 5-5 5"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  del: (
    <>
      <path d="M6 4h8v8H6L2 8z" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M8.5 6.5l3 3M11.5 6.5l-3 3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </>
  ),
  warn: (
    <>
      <path
        d="M8 2l6.5 11.5h-13z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
      <path d="M8 6.5v3.2M8 11.6v.1" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </>
  ),
  list: (
    <>
      <path d="M5.5 4h8M5.5 8h8M5.5 12h8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <circle cx="2.6" cy="4" r="1.1" fill="currentColor" />
      <circle cx="2.6" cy="8" r="1.1" fill="currentColor" />
      <circle cx="2.6" cy="12" r="1.1" fill="currentColor" />
    </>
  ),
  user: (
    <>
      <circle cx="8" cy="5.3" r="2.8" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="M2.5 14c.6-2.9 2.8-4.4 5.5-4.4s4.9 1.5 5.5 4.4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </>
  ),
  chart: (
    <>
      <path d="M2 14h12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M4 11V8M8 11V3.5M12 11V6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
    </>
  ),
  grid: (
    <>
      <rect x="2" y="2" width="5" height="5" rx="1.2" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <rect x="9" y="2" width="5" height="5" rx="1.2" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <rect x="2" y="9" width="5" height="5" rx="1.2" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <rect x="9" y="9" width="5" height="5" rx="1.2" fill="none" stroke="currentColor" strokeWidth="1.7" />
    </>
  ),
  gear: (
    <>
      <circle cx="8" cy="8" r="2.3" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <path
        d="M8 1.8v2M8 12.2v2M1.8 8h2M12.2 8h2M3.6 3.6l1.4 1.4M11 11l1.4 1.4M3.6 12.4L5 11M11 5l1.4-1.4"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </>
  ),
  phone: (
    <path
      d="M4.5 2h2l1 3-1.5 1a8 8 0 0 0 4 4l1-1.5 3 1v2a1.5 1.5 0 0 1-1.6 1.5A11.5 11.5 0 0 1 3 3.6 1.5 1.5 0 0 1 4.5 2z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
  ),
  grip: (
    <>
      {[4, 8, 12].map((y) => (
        <g key={y}>
          <circle cx="6" cy={y} r="1.2" fill="currentColor" />
          <circle cx="10" cy={y} r="1.2" fill="currentColor" />
        </g>
      ))}
    </>
  ),
  sync: (
    <path
      d="M13 6.5A5.2 5.2 0 0 0 3.3 5M3 9.5A5.2 5.2 0 0 0 12.7 11M13 3v3.5H9.5M3 13V9.5h3.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  offline: (
    <>
      <path
        d="M2 6.2a9 9 0 0 1 12 0M4.3 8.6a5.6 5.6 0 0 1 7.4 0M6.6 11a2.2 2.2 0 0 1 2.8 0"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path d="M2.5 2.5l11 11" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </>
  ),
  download: (
    <path
      d="M8 2.5v8M4.5 7L8 10.5 11.5 7M3 13.5h10"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  calendar: (
    <>
      <rect x="2" y="3" width="12" height="11" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <path
        d="M2 6.5h12M5 1.8v2.4M11 1.8v2.4"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </>
  ),
  camera: (
    <>
      <path
        d="M2 5.5h2.5L6 3.5h4l1.5 2H14v7.5H2z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <circle cx="8" cy="9" r="2.3" fill="none" stroke="currentColor" strokeWidth="1.6" />
    </>
  ),
  /* reason icons */
  box: (
    <path
      d="M2.5 5L8 2.5 13.5 5v6L8 13.5 2.5 11zM2.5 5L8 7.5 13.5 5M8 7.5v6"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
  ),
  palette: (
    <>
      <path
        d="M8 2a6 6 0 1 0 0 12c1 0 1.3-.8.9-1.5-.5-.9 0-1.8 1.1-1.8H12a2.5 2.5 0 0 0 2-2.7A6 6 0 0 0 8 2z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <circle cx="5" cy="7" r="1" fill="currentColor" />
      <circle cx="8" cy="5" r="1" fill="currentColor" />
      <circle cx="11" cy="7" r="1" fill="currentColor" />
    </>
  ),
  tool: (
    <path
      d="M10.5 2.5a3 3 0 0 0-3 4L2.5 11.5l2 2 5-5a3 3 0 0 0 4-3l-2 1-1.5-1.5z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
  ),
  truck: (
    <>
      <path
        d="M1.5 4h8v7h-8zM9.5 6.5h3l2 2.5V11h-5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <circle cx="4.5" cy="12" r="1.4" fill="var(--surface, #fff)" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="11.5" cy="12" r="1.4" fill="var(--surface, #fff)" stroke="currentColor" strokeWidth="1.5" />
    </>
  ),
  swap: (
    <path
      d="M3 5h9l-2.5-2.5M13 11H4l2.5 2.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  scale: (
    <path
      d="M8 2.5v11M4 13.5h8M3 5h10M3 5l-1.5 4h3zM13 5l-1.5 4h3z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  ),
  repeat: (
    <path
      d="M3 7V6a2 2 0 0 1 2-2h8l-2-2M13 9v1a2 2 0 0 1-2 2H3l2 2"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  scratch: (
    <path
      d="M3 11l4-6M6 13l6-9M10 13l3-4"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
  ),
  ruler: (
    <path
      d="M2 11L11 2l3 3-9 9zM5 8l1.5 1.5M7 6l1.5 1.5M9 4l1.5 1.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  ),
  flask: (
    <path
      d="M6 2h4M6.5 2v4L3 13h10L9.5 6V2M4.5 10h7"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
      strokeLinecap="round"
    />
  ),
  doc: (
    <path
      d="M4 1.8h5.5L12.5 5v9.2H4zM9.5 1.8V5h3M6 8h4.5M6 10.8h4.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  ),
  eye: (
    <>
      <path
        d="M1.5 8S4 3.5 8 3.5 14.5 8 14.5 8 12 12.5 8 12.5 1.5 8 1.5 8z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <circle cx="8" cy="8" r="2" fill="none" stroke="currentColor" strokeWidth="1.6" />
    </>
  ),
} as const;

export type IconName = keyof typeof PATHS;
export const ICON_NAMES = Object.keys(PATHS) as IconName[];

export function Icon({ name, size, ...rest }: { name: IconName; size?: number } & SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="i"
      viewBox="0 0 16 16"
      aria-hidden="true"
      focusable="false"
      {...(size ? { width: size, height: size, style: { width: size, height: size } } : {})}
      {...rest}
    >
      {PATHS[name]}
    </svg>
  );
}
